import {useTranslation} from 'react-i18next';
import ICON_DELETE_LIGHT from '../../../public/static/v4/search/icon-delete-btn-light.svg';
import ICON_DELETE from '../../../public/static/v4/search/icon-delete-btn.svg';
import ICON_SEARCH_LIGHT from '../../../public/static/v4/search/icon-search-light.svg';
import ICON_SEARCH from '../../../public/static/v4/search/icon-search.svg';
import Anchor from '../../common/component/Anchor';
import Button from '../../common/component/Button';
import SingleText from '../../common/component/SingleText';
import Text from '../../common/component/Text';
import useTheme from '../../common/hook/useTheme';
import {sendSearchEventV4} from '../common';

interface IProps {
  keywords: string[];
  deleteKeyword: (keyword: string) => void;
  search: (keyword: string) => void;
}

export default function RecentListV4({
  keywords,
  deleteKeyword,
  search,
}: IProps) {
  const {t} = useTranslation();
  const {isLightMode} = useTheme();

  const onClickKeyword = (keyword: string, idx: number) => {
    sendSearchEventV4({
      viewType: 'searchView',
      actionName: 'recent_keyword',
      customProps: {
        event_layer: 'search',
        ordnum: idx + 1,
        click_keyword: keyword,
      },
    });

    search(keyword);
  };

  const onClickDeleteBtn = (keyword: string) => {
    sendSearchEventV4({
      viewType: 'searchView',
      actionName: 'recent_keyword_delete',
      customProps: {event_layer: 'search', click_keyword: keyword},
    });

    deleteKeyword(keyword);
  };

  return (
    <div className="my-20 mx-18">
      <Text className="s14-medium-grey08">{t('search_recent')}</Text>
      <ul className="mt-20">
        {keywords.map((keyword, idx) => {
          return (
            <li key={idx} className="flex items-center mb-28">
              <Anchor
                display="flex"
                className="flex-1 overflow-hidden flex items-center"
                onClick={() => {
                  onClickKeyword(keyword, idx);
                }}
              >
                <img
                  className="flex-none w-28 h-28"
                  src={isLightMode ? ICON_SEARCH_LIGHT : ICON_SEARCH}
                  alt={t('search_title')}
                />
                <SingleText className="ml-14 s17-medium-white light:text-black">
                  {keyword}
                </SingleText>
              </Anchor>
              <Button className="flex-none ml-14 w-20 h-28">
                <img
                  className="w-20 h-20"
                  src={isLightMode ? ICON_DELETE_LIGHT : ICON_DELETE}
                  alt={t('common_delete')}
                  onClick={() => {
                    onClickDeleteBtn(keyword);
                  }}
                />
              </Button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
